import * as z from "zod/v4";

export const getWorkOrderBomNames = {
  name: "getWorkOrderBomNames" as const,
  input: z.object({}),
  output: z.object({ names: z.array(z.string()) }),
};
